const eventListeners = new Map();

/**
 * @param {Record<keyof WindowEventMap, EventListener[]>} options
 */
export default function (options = {}) {
  return {
    mounted () {
      for (const [event, listener] of Object.entries(options)) {
        if (!eventListeners.has(event)) {
          window.addEventListener(event, e => this.callEvent(event, e));

          eventListeners.set(event, [listener.bind(this)]);
          return;
        }

        const listeners = eventListeners.get(event);
        listeners.push(listener.bind(this));

        eventListeners.set(event, listeners);
      }
    },

    destroyed () {
      for (const [event, listener] of Object.entries(options)) {
        const listeners = eventListeners.get(event);

        listeners.splice(listeners.indexOf(listener), 1);

        if (listeners.length === 0) {
          eventListeners.delete('event');
        } else {
          eventListeners.set(event, listeners);
        }
      }
    },

    methods: {
      getEventMap () {
        return eventListeners;
      },

      callEvent (event, data) {
        const listeners = eventListeners.get(event);

        if (!listeners) {
          return;
        }

        listeners.forEach(x => x(data));
      }
    }
  };
}
